export default {
  specialization: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/specializations/resources/props.js